export default {
  // possible value: visible, hidden, readonly
  divisionPickerState: 'visible',
  beforeCreate() {
    let { divisionPickerState } = this.$options
    if (this.$route.meta.withoutDivision && divisionPickerState != 'readonly') {
      divisionPickerState = 'hidden'
    }
    this.$store.commit('setDivisionPickerState', divisionPickerState)
  }
}
